import { Empty, Heading, Link, Spinner } from "ui-components";

import { makeToast } from "@/src/components/Toast/Toast";
import {
  BlockedUserResponse,
  useUserBlockUserToggle,
} from "@/src/hooks/api/generated";

import MemberInfoCard from "./MemberInfoCard";

export interface IBlockedMembersListing {
  blockUsersFetchingStatus: "error" | "idle" | "pending" | "success";
  blockUsersData?: BlockedUserResponse;
  refetchBlockUsers: () => void;
}

export function BlockedMembersListing({
  blockUsersData,
  blockUsersFetchingStatus,
  refetchBlockUsers,
}: IBlockedMembersListing): JSX.Element {
  const { mutate: userBlockUserToggle } = useUserBlockUserToggle();

  function handleUnblockMember(userId: number): void {
    userBlockUserToggle(
      {
        data: {
          userId,
        },
      },
      {
        onSuccess: () => {
          refetchBlockUsers();
          makeToast({
            title:
              "The user has been successfully unblocked. Please note that you will need to reconnect the user to your contacts if you want to message them again.",
            intent: "success",
          });
        },
        onError: () => {
          makeToast({
            title: "Something went wrong.",
            intent: "danger",
          });
        },
      }
    );
  }

  const cardOptions = [
    {
      title: "Unblock user",
      action: handleUnblockMember,
    },
  ];

  return (
    <>
      <div className="flex justify-between items-center">
        <Heading variant="h2">
          Blocked Members ({blockUsersData?.total})
        </Heading>
        <Link href="/connections/blocked">See all</Link>
      </div>
      {blockUsersData?.data.length === 0 && (
        <Empty className="mb-5" text="No blocked members." />
      )}
      {blockUsersFetchingStatus === "pending" && (
        <div className="flex justify-center mt-10 w-full">
          <Spinner size="lg" intent="brand-primary" />
        </div>
      )}

      <div className="flex flex-wrap">
        {blockUsersData?.data.map((user) => (
          <div key={user.id} className="p-2.5 w-full  md:w-1/2">
            <MemberInfoCard
              user={user.user}
              options={cardOptions}
              isShowAllDetails={false}
              isBlockedMember
              onUnBlockAccount={() => handleUnblockMember(user.user.id)}
            />
          </div>
        ))}
      </div>
      <Link href="/connections/blocked" className="text-center mt-2.5">
        See all
      </Link>
    </>
  );
}
